import { UsesAuthenticatedUser } from '@/mixins/index'

export default {
  mixins: [ UsesAuthenticatedUser ],
  props: {
    selectedKintellGroup: {
      type: [ Object, Array ],
      default: {}
    }
  },
  computed: {
    kintellGroups () {
      const kintellGroups = this.authenticatedUser?.kintellGroups

      if (kintellGroups?.length) {
        return kintellGroups
      }

      return false
    },
  }
}
